import { useContext, useEffect, useState } from 'react';
import { StyledRate } from './style';

const valueMap = {
  null: 0,
  undefined: 0,
  '': 0,
  'Tier 1': 5,
  'Tier 2': 4,
  'Tier 3': 3,
  'Tier 4': 2,
  'Tier 5': 1,
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
};

type Props = {
  defaultValue: string | number;
  onChange?: (value: number) => void;
  disabled?: boolean;
};

const CustomStar = ({ index, value }: { index: number; value: number }) => {
  if (index < value) {
    return <img src="/img/profile/rocket_red.png" style={{ height: '18px' }} />;
  } else {
    return <img src="/img/profile/rocket_white.png" style={{ height: '18px' }} />;
  }
};

const ImpactFactor = ({ defaultValue, onChange, disabled }: Props): JSX.Element => {
  console.log('defaultValue: ', defaultValue);
  const [value, setValue] = useState<number>(valueMap[defaultValue as keyof typeof valueMap]);
  useEffect(() => {
    setValue(valueMap[defaultValue as keyof typeof valueMap]);
  }, [defaultValue]);

  return (
    <StyledRate
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      character={CustomStar as any}
      value={value}
      onChange={(value: number) => {
        setValue(value);
        if (onChange) {
          onChange(value);
        }
      }}
      disabled={disabled}
    />
  );
};

export default ImpactFactor;
